(function () {
  'use strict';

  function applyFix(variantRadios) {
    if (variantRadios.dataset.fixApplied) return;
    variantRadios.dataset.fixApplied = 'true';

    const intent = new WeakMap();

    function lockRadio(input) {
      if (input.__fixLocked) return;
      input.__fixLocked = true;

      const desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');

      Object.defineProperty(input, 'checked', {
        configurable: true,
        get() {
          return desc.get.call(this);
        },
        set(value) {
          const fieldset = this.closest('fieldset');
          const wanted = fieldset ? intent.get(fieldset) : null;

          if (wanted === this && value === false) return;
          if (wanted && wanted !== this && this.name === wanted.name && value === true) return;

          desc.set.call(this, value);
        }
      });
    }

    variantRadios.querySelectorAll('input[type="radio"]').forEach(lockRadio);

    new MutationObserver(muts => {
      muts.forEach(m => {
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('input[type="radio"]')) lockRadio(node);
          node.querySelectorAll && node.querySelectorAll('input[type="radio"]').forEach(lockRadio);
        });
      });

      variantRadios.querySelectorAll('fieldset').forEach(fs => {
        const wanted = intent.get(fs);
        if (!wanted || !document.contains(wanted)) return;
        const sameValue = fs.querySelector(`input[type="radio"][value="${CSS.escape(wanted.value)}"]`);
        if (sameValue) {
          intent.set(fs, sameValue);
          lockRadio(sameValue);
          if (!sameValue.checked) {
            const desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
            desc.set.call(sameValue, true);
          }
        }
      });
    }).observe(variantRadios, { childList: true, subtree: true });

    document.addEventListener('click', function (e) {
      const target = e.target;
      let input = null;

      if (target.matches && target.matches('input[type="radio"][name="size"]')) {
        input = target;
      } else {
        const label = target.closest && target.closest('label[for]');
        if (label) {
          const candidate = document.getElementById(label.getAttribute('for'));
          if (candidate && candidate.type === 'radio' && candidate.name === 'size') {
            input = candidate;
          }
        }
      }

      if (!input) return;
      const fieldset = input.closest('fieldset');
      if (!fieldset || !variantRadios.contains(fieldset)) return;

      intent.set(fieldset, input);
      lockRadio(input);

      const desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
      fieldset.querySelectorAll('input[type="radio"]').forEach(r => {
        desc.set.call(r, r === input);
      });

      setTimeout(() => {
        if (typeof variantRadios.onVariantChange === 'function') {
          variantRadios.onVariantChange();
        } else {
          variantRadios.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 0);

    }, true);
  }

  function init() {
    document.querySelectorAll('variant-radios').forEach(applyFix);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();